import React from 'react';
import { Box, VStack, Heading, Text } from '@companydotcom/potion';
import { FontAwesomeIcon } from '@companydotcom/ui';
import { faChartTreeMap } from '@fortawesome/pro-thin-svg-icons';
import { useTranslation } from 'react-i18next';

export const FaceCakeIntegrationTile = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <VStack spacing="2">
        <FontAwesomeIcon
          icon={faChartTreeMap}
          color="pink.500"
          boxSize={{ base: '12', xl: '16' }}
        />
        <Heading size="lg" color="pink.500" fontWeight="bold">
          {t('icommerce.tileStatus.integration.header')}
        </Heading>
        <Text>{t('icommerce.tileStatus.integration.body')}</Text>
      </VStack>
    </Box>
  );
};
